// extracted by mini-css-extract-plugin
module.exports = {"btnWrap":"style_btnWrap__1LGFF","button":"style_button__3vUE9"};